export default "__VITE_ASSET__BTG$p1GX__"